export const state = {
    restaurants: [],
    unsavedNotificationsChanges: false,
};

export default state;
